export default __webpack_public_path__ + "static/Spainsunderwatersuperplant copy-b6146d6e7bdf6e626e5f1d775c213209.jpg";